import type { GetInternalAuditReportObligationResultsByObligationIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationInternalAuditResultsByObligationIdArgs = {
  obligationId: string;
};

export const useGetObligationInternalAuditResultsByObligationId =
  createQueryHook<
    UseGetObligationInternalAuditResultsByObligationIdArgs,
    GetInternalAuditReportObligationResultsByObligationIdResponseRow[],
    GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery
  >({
    trpcQueryOptions: (trpc, { obligationId }) =>
      trpc.frontend.internalAuditResult.obligationInternalAuditResultsByObligationId.queryOptions(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      obligation_internal_audit_result: data,
    }),
    graphqlDocument:
      GetInternalAuditReportObligationAssessmentResultsByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
